import React from 'react';
import {Button, Modal} from 'antd';
import "../../assets/css/Dentobook.css";
import "../../assets/css/PatientPhotos.css";
import {FormattedMessage} from "react-intl";
import '../../assets/css/PatientCreateModal.css';
import {CloseOutlined} from "@ant-design/icons";

interface SignatureClientErrorModalProps {
    isModalOpen: boolean;
    setIsModalOpen: Function;
}

const SignatureClientErrorModal = ({isModalOpen, setIsModalOpen}: SignatureClientErrorModalProps) => {

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const footer = <div className="modal-btn-wrapper">
        <Button className="modal-btn text-blue font-weight-500 modal-btn-full-width" onClick={handleCancel} style={{color: ''}}>
            {<FormattedMessage id="close"/>}
        </Button>
    </div>

    return <Modal
        transitionName=""
        className="dentobook-modal dentobook-small-modal"
        width={570}
        cancelButtonProps={{
            className: "modal-btn"
        }}
        footer={footer}
        open={isModalOpen} onCancel={handleCancel}>
        <div className="signature-error mb-8">
            <p className="font-weight-500 font-24 font-family-roboto text-align-center">
                <FormattedMessage id="signature_client_not_found"/>
            </p>
            <p className="font-weight-500 font-24 font-family-roboto text-align-center">
                <FormattedMessage id="signature_client_start"/> <a className="text-underline" href="https://dentobook.com/esign_app/" target="_blank"><FormattedMessage id="here_msg"/></a>.
            </p>
        </div>
    </Modal>;
};

export default SignatureClientErrorModal;